import { combineReducers } from 'redux'
import { IPagination } from '../../../types/pagination'
import { IProject } from '../../project/types/project'
import {
  IDataLoader,
  IDepartmentUtilizationFilterData, IFTEByProject, IGlobalReportDepartmentUtilizationData,
  IGlobalReportExpectedPaymentsData,
  IGlobalReportExpenditurePhasingData, IGlobalReportHoursPhasingData, IProjectHoursPhasingFilterData,
  IProjectList, IProjectListFilterData, IReport, IReportChart, IReportFilter, ITasksByProject, ITasksByProjectFilterData
} from './../types/reports'
import {
  FTEByProject, FTEByProjectFilter, FTEByProjectSort, checkDataLoader,
  checkLoader, departmentUtilization, departmentUtilizationChart, departmentUtilizationChartDataType, departmentUtilizationFilter,
  departmentUtilizationSort, expectedPayments, expectedPaymentsChart, expectedPaymentsChartDataType, expectedPaymentsFilter,
  expectedPaymentsSort, expectedReceipts, expectedReceiptsChart, expectedReceiptsChartDataType, expectedReceiptsFilter,
  expectedReceiptsSort, expenditurePhasing, expenditurePhasingChart, expenditurePhasingChartDataType, expenditurePhasingSort,
  paginatedTasksByProject, paginationPageDepartmentUtilization,
  paginationPageExpectedPayments, paginationPageExpectedReceipts, paginationPageExpenditurePhasing, paginationPageFTEByProject,
  paginationPageProjectHoursPhasing, paginationPageProjectList, paginationPageTasksByProject, projectHoursPhasing,
  projectHoursPhasingChart, projectHoursPhasingChartDataType, projectHoursPhasingFilter, projectHoursPhasingSort,
  projectList, projectListFilter, projectListSort, reports, reportsFilter, reportsFilters,
  tasksByProjectSort,
  tasksByProjectsFilter
} from './reportsReducer'


export interface ReportsState {
  reports: IReport[]
  reportsFilters: IReportFilter[]
  reportsFilter: IReportFilter
  tasksByProjectsFilter: ITasksByProjectFilterData
  checkLoader: boolean
  tasksByProjectSort: { name: string, direction: string }
  projectListFilter: IProjectListFilterData
  projectList: IPagination<IProject[]>
  projectListSort: { name: string, direction: string }
  FTEByProjectFilter: IProjectList
  FTEByProject: IFTEByProject
  FTEByProjectSort: { name: string, direction: string }
  expenditurePhasing: IGlobalReportExpenditurePhasingData
  expenditurePhasingSort: { name: string, direction: string }
  expenditurePhasingChartDataType: { type: string, year: number }
  expenditurePhasingChart: IReportChart
  departmentUtilizationFilter: IDepartmentUtilizationFilterData
  departmentUtilization: IGlobalReportDepartmentUtilizationData
  departmentUtilizationSort: { name: string, direction: string }
  departmentUtilizationChartDataType: { type: string, year: number }
  departmentUtilizationChart: IReportChart
  projectHoursPhasingFilter: IProjectHoursPhasingFilterData
  projectHoursPhasing: IGlobalReportHoursPhasingData
  projectHoursPhasingSort: { name: string, direction: string }
  projectHoursPhasingChartDataType: { type: string, year: number }
  projectHoursPhasingChart: IReportChart
  expectedPaymentsFilter: IProjectList
  expectedPayments: IGlobalReportExpectedPaymentsData
  expectedPaymentsChart: IReportChart
  expectedPaymentsSort: { name: string, direction: string }
  expectedPaymentsChartDataType: { type: string, year: number }
  expectedReceiptsFilter: IProjectList
  expectedReceipts: IGlobalReportExpectedPaymentsData
  expectedReceiptsChart: IReportChart
  expectedReceiptsSort: { name: string, direction: string }
  expectedReceiptsChartDataType: { type: string, year: number }
  paginatedTasksByProject: IPagination<ITasksByProject[]>
  paginationPageTasksByProject: string
  paginationPageExpenditurePhasing: string
  paginationPageFTEByProject: string
  paginationPageProjectList: string
  paginationPageDepartmentUtilization: string
  paginationPageProjectHoursPhasing: string
  paginationPageExpectedPayments: string
  paginationPageExpectedReceipts: string
  checkDataLoader: IDataLoader
}

const reportsApp = combineReducers<ReportsState>({
  reports,
  reportsFilters,
  reportsFilter,
  tasksByProjectsFilter,
  checkLoader,
  tasksByProjectSort,
  projectListFilter,
  projectList,
  projectListSort,
  FTEByProjectFilter,
  FTEByProject,
  FTEByProjectSort,
  expenditurePhasing,
  expenditurePhasingSort,
  expenditurePhasingChartDataType,
  expenditurePhasingChart,
  departmentUtilizationFilter,
  departmentUtilization,
  departmentUtilizationSort,
  departmentUtilizationChartDataType,
  departmentUtilizationChart,
  projectHoursPhasingFilter,
  projectHoursPhasing,
  projectHoursPhasingSort,
  projectHoursPhasingChartDataType,
  projectHoursPhasingChart,
  expectedPaymentsFilter,
  expectedPayments,
  expectedPaymentsChart,
  expectedPaymentsSort,
  expectedPaymentsChartDataType,
  expectedReceiptsFilter,
  expectedReceipts,
  expectedReceiptsChart,
  expectedReceiptsSort,
  expectedReceiptsChartDataType,
  paginatedTasksByProject,
  paginationPageTasksByProject,
  paginationPageExpenditurePhasing,
  paginationPageFTEByProject,
  paginationPageProjectList,
  paginationPageDepartmentUtilization,
  paginationPageProjectHoursPhasing,
  paginationPageExpectedPayments,
  paginationPageExpectedReceipts,
  checkDataLoader
})

export default reportsApp
